import React from 'react';
import { Navbar, Container, Button } from 'react-bootstrap';
import { User } from '../types/user';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
    user: User;
    onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ user, onLogout }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        onLogout();
        navigate('/login');
    };

    return (
        <Navbar bg="light" variant="light" className="border-bottom">
            <Container>
                <Navbar.Brand href="#home">Sistema de Contratos</Navbar.Brand>
                <div className="d-flex align-items-center">
                    <span className="me-3">
                        <strong>Usuario:</strong> {user.Description}
                    </span>
                    <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={handleLogout}
                    >
                        Cerrar Sesión
                    </Button>
                </div>
            </Container>
        </Navbar>
    );
};

export default Header; 